import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from 'axios';
import { baseAPI } from '../config';

const settingsStore = create(
  persist(
    (set, get) => ({
      // Maytapi phones
      maytapiPhones: [],
      setMaytapiPhones: phones => set({ maytapiPhones: Array.isArray(phones) ? phones : [] }),
      addMaytapiPhone: phone => set(state => ({ maytapiPhones: [...state.maytapiPhones, phone] })),
      updateMaytapiPhone: updated =>
        set(state => ({
          maytapiPhones: state.maytapiPhones.map(p => (p._id === updated._id ? { ...p, ...updated } : p)),
        })),
      clearSettings: () => set({ maytapiPhones: [], aircallPhones: [] }),
      refreshMaytapiPhones: async () => {
        try {
          const token = localStorage.getItem('token');
          const headers = token ? { Authorization: `Bearer ${token}` } : {};
          const response = await axios.get(`${baseAPI}/settings/phones`, { headers });
          const list = Array.isArray(response.data?.data) ? response.data?.data : [];
          set({ maytapiPhones: list });
          return list;
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('Error refreshing Maytapi phones:', err);
          throw err;
        }
      },
      // Aircall phones
      aircallPhones: [],
      setAircallPhones: phones => set({ aircallPhones: Array.isArray(phones) ? phones : [] }),
      refreshAircallPhones: async () => {
        try {
          const token = localStorage.getItem('token');
          const headers = token ? { Authorization: `Bearer ${token}` } : {};
          const response = await axios.get(`${baseAPI}/settings/aircall`, { headers });
          const list = Array.isArray(response.data?.data) ? response.data?.data : [];
          set({ aircallPhones: list });
          return list;
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('Error refreshing Aircall phones:', err);
          throw err;
        }
      },
      syncAircallPhones: async () => {
        try {
          const token = localStorage.getItem('token');
          const headers = token ? { Authorization: `Bearer ${token}` } : {};
          const response = await axios.post(`${baseAPI}/settings/aircall/sync`, {}, { headers });
          // Refrescar la lista después de sincronizar
          await get().refreshAircallPhones();
          return response.data?.data || {};
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('Error syncing Aircall phones:', err);
          throw err;
        }
      },
    }),
    { name: 'settings-store' }
  )
);

export default settingsStore;
